
import Swal from 'sweetalert2';
import './AlertDialog.css';

export function AlertError(text,  onclick){
    return (
        Swal.fire({
            icon: 'error',
            title: 'แจ้งเตือน',
            text: text,
            confirmButtonText: 'ตกลง',
        }).then(()=>{
            onclick();
        })
    );
}

export function AlertWarning(text, onclick){
    return (
        Swal.fire({
            icon: 'warning',
            title: 'แจ้งเตือน',
            text: text,
            confirmButtonText: 'ตกลง',
        }).then(()=>{
            onclick();
        })
    );
}

export function AlertSuccess(text, onclick, timer){
    return (
        Swal.fire({
            icon: 'success',
            title: 'แจ้งเตือน',
            text: text,
            confirmButtonText: 'ตกลง',
            timer: timer ? timer : null
        }).then(()=>{
            onclick();
        })
    );
}

export function AlertConfirm(text, onClick, timer){
    return (
        Swal.fire({
            icon: 'warning',
            title: 'แจ้งเตือน',
            text: text,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
        }).then((result)=>{
            if (result.isConfirmed) {
                onClick();
            }
        })
    );
}